import { Expose } from 'class-transformer';
import { Model } from '@shared/models/model';

export class Coordinate extends Model {
  @Expose() longitude: number;
  @Expose() latitude: number;

  constructor() {
    super();
  }
}
